import { __decorate } from "tslib";
import { Component } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvCarouselSlide";
/**
 * A slide for the carousel component
 */
let LvCarouselSlide = class LvCarouselSlide extends UIComponent {
};
LvCarouselSlide = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvCarouselSlide);
export default LvCarouselSlide;
//# sourceMappingURL=script.js.map